<template>
  <div>
    <router-view v-if="$route.name !== 'stands-index'" :key="$route.fullPath"></router-view>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title" v-translate>Stands at the event</h4>
              </div>
              <div class="col-md-6 text-right">
                <router-link class="btn btn-success" :to="{name: 'stands-add'}" v-if="$auth.user().isSuperuser"><i class="nc-icon nc-simple-add"></i>&nbsp;<span v-translate>Add stand</span></router-link>
              </div>
            </div>
          </div>
          <paginated-table :table-data="[]" :remote-url="`expostat/event/${currentEvent}/stands/`" :per-page="10"
                           ref="table"
                           default-ordering="-my_stand"
                           :search-fields="['title', 'name']" v-if="currentEvent">
            <template slot-scope="slot" slot="tableColumns">
              <el-table-column width="120">
                <template slot-scope="props">
                  <div class="img-container" v-if="props.row.logoUrl">
                    <img :src="props.row.logoUrl" :alt="props.row.name" class="img img-responsive">
                  </div>
                  <h4 class="text-center" v-else><translate>No logo</translate></h4>
                </template>
              </el-table-column>
              <el-table-column
                sortable="custom" sort-by="title"
                :label="'Name' | translate">
                <template slot-scope="props">
                  <strong>{{props.row.name}}</strong>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                class="td-stand-number"
                sortable="custom" sort-by="stand_number"
                :label="'Stand number' | translate">
                <template slot-scope="props">
                  {{props.row.standNumber || '-'}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="50"
                class-name="td-stand-counts"
                sortable="custom" sort-by="attachments_count"
                :label="'Information' | translate">
                <template slot-scope="props">
                  <p><translate>Materials:</translate> {{props.row.materialsCount || 0}}</p>
                  <p><translate>Attachments:</translate> {{props.row.attachmentsCount || 0}}</p>
                  <router-link :to="{name: 'stands-persons', params: {standId: props.row.id}}" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[props.row.id]">
                    <p v-if="props.row.visitCount !== undefined && props.row.visitCount !== null"><translate>Visits:</translate> {{props.row.visitCount || 0}}</p>
                    <p v-if="props.row.interestedCount !== undefined && props.row.interestedCount !== null"><translate>Interested:</translate> {{props.row.interestedCount || 0}}</p>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                class-name="action-buttons td-actions"
                align="right"
                :label="'Actions' | translate">
                <template slot-scope="props">
                  <el-tooltip :content="'Edit' | translate" placement="top" v-if="$auth.user().isSuperuser || $root.expoStatPermissions.stands[props.row.id]">
                    <router-link :to="{name: 'stands-edit', params: {standId: props.row.id}}" class="btn btn-icon btn-success btn-sm" tag="a">
                      <i class="fa fa-edit"></i>
                    </router-link>
                  </el-tooltip>
                  <el-tooltip :content="'Delete' | translate" placement="top" v-if="$auth.user().isSuperuser">
                    <p-button type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">
                      <i class="fa fa-times"></i>
                    </p-button>
                  </el-tooltip>
                  <el-tooltip :content="'More Info' | translate" placement="top">
                    <router-link :to="{name: 'stands-details', params: {standId: props.row.id, standInfo: props.row}}"
                                 class="btn btn-icon btn-secondary btn-sm" tag="a">
                      <i class="fa fa-chevron-circle-right"></i>
                    </router-link>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
          </paginated-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Table, TableColumn, Tooltip} from 'element-ui'
  import PaginatedTable from 'src/components/Expostat/Components/PaginatedTable'
  import swal from 'sweetalert2'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    computed: {
      ...mapState({
        currentEvent: state => state.events.current,
        currentEventInfo: state => state.events.currentEventInfo,
        // available: state => state.events.available
      }),
      // ...mapGetters({currentEventInfo: 'events/currentEventInfo'}),
    },
    breadcrumb () {
      return {
        label: this.$gettext('Stands list'),
        parent: {
          name: "event-root"
        }
      }
    },
    components: {
      PaginatedTable,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip
    },
    mounted () {
      this.$route.meta.title = `Стенды`
    },
    data () {
      return {
      }
    },
    methods: {
      hasEditPermission (row) {
        debugger
      },
      handleDelete (event, index, row) {
        const vm = this
        event.stopPropagation()
        let message = this.$gettext('<span>Do you really want to remove the stand <strong>%{name}</strong>?</span></br><span>It will be impossible to recover information!</span>')
        swal({
          title: this.$gettext('Are you sure?'),
          html: this.$gettextInterpolate(message, {name: row.name}),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$gettext('Yes, delete it!'),
          cancelButtonText: this.$gettext('No, keep it'),
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          vm.$http.delete(`expostat/event/${vm.currentEvent}/stands/${row.id}/`).then(result => {
            let message = vm.$gettext('<span>Stand <strong>%{name}</strong> successfully deleted.</span>')
            swal({
              title: vm.$gettext('Successful delete'),
              html: vm.$gettextInterpolate(message, {name: row.name}),
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
            vm.$refs.table.fetchData()
          }).catch(error => {
            let message = vm.$gettext('<span>Failed to delete stand <strong>%{name}</strong><br>Status: %{statusCode}<br>Message: <code>%{details}</code></span>')
            let statusCode = error.response.status
            let details = ''
            if (error.response.data && error.response.data.detail) {
              details = error.response.data.detail
            }
            swal({
              title: vm.$gettext('Error'),
              html: vm.$gettextInterpolate(message, {name: row.name, statusCode, details}),
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          // if (dismiss === 'cancel') {
          //   swal({
          //     title: 'Cancelled',
          //     text: 'Your imaginary file is safe :)',
          //     type: 'error',
          //     confirmButtonClass: 'btn btn-info btn-fill',
          //     buttonsStyling: false
          //   })
          // }
        })
      }
    }
  }
</script>

<style>
  .el-table th.break-words>.cell {
    word-break: break-word;
  }

  .el-table th.cell {
    padding-left: 2px;
    padding-right: 2px;
  }

  .td-stand-counts p {
    margin-bottom: 0;
  }

</style>
